import React from "react";
import PropTypes from "prop-types";
import "../styles/BlogsCard.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const BlogsCard = ({ title, description, url, coverImage, publicReaction, readTime, darkTheme }) => {
  return (
    <div className="blog-card" style={{
        background: darkTheme
          ? "linear-gradient(167deg, #000000 21%, #273a3a)"
          : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
      }}>
      <img src={coverImage} alt={title} className="blog-card__image" />
      <div className="blog-card__content">
        <h2 className="blog-card__title">{title}</h2>
        <p className="blog-card__description">{description}</p>
        <div className="blog-card__meta">
          <span className="blog-card__public-reaction"><FontAwesomeIcon icon={faHeart} size="sm" color="red" /> {publicReaction}</span>
          <span className="blog-card__read-time">{readTime} min read</span>
        </div>
        <a href={url} className="blog-card__link" target="_blank" rel="noopener noreferrer">
          Read more
        </a>
      </div>
    </div>
  );
};

BlogsCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  coverImage: PropTypes.string.isRequired,
  publicReaction: PropTypes.number.isRequired,
  readTime: PropTypes.number.isRequired,
};

export default BlogsCard;
